import { ChainTab, ChainTabList, ChainTabPanel, ChainTabs } from "./ChainTabs.jsx";
import Icon, { iconTypes } from "../../common/components/Icon.jsx";
import { SubMenu, SubMenuItem } from "../../common/components/SubMenu.jsx";

import { Localization } from "../../common/util/localization.jsx";
import MultiProductModal from "./MultiProductModal.jsx";
import PropTypes from "prop-types";
import React from "react";
import SingleChainSortimentList from "./SingleChainSortimentList.jsx";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class SingleChainSortimentCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            multiSelectOn: false,
        };

        this.swallowOnClick = this.swallowOnClick.bind(this);
        this.onTabAllClicked = this.onTabAllClicked.bind(this);
        this.onTabNewClicked = this.onTabNewClicked.bind(this);
        this.onMultiSelectClick = this.onMultiSelectClick.bind(this);
        this.onEditMultiSelect = this.onEditMultiSelect.bind(this);
        this.calculateInternalPanelHeight = this.calculateInternalPanelHeight.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.onExportCsv = this.onExportCsv.bind(this);
    }

    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
        this.props.clearChainProductDetails();
    }

    onTabAllClicked() {
        const path = this.props.location.pathname;
        //replace only whats after the last / with the new path
        this.props.history.replace(`${path.substr(0, path.lastIndexOf("/"))}/all`);
        this.props.editSingleChainFilter({
            onlyNews: false,
        });
    }

    onTabNewClicked() {
        const path = this.props.location.pathname;
        //replace only whats after the last / with the new path
        this.props.history.replace(`${path.substr(0, path.lastIndexOf("/"))}/new`);
        this.props.editSingleChainFilter({
            onlyNews: true,
        });
    }

    onMultiSelectClick() {
        if( this.state.multiSelectOn ){
            this.props.clearSelectedProducts();
        }
        this.setState({
            multiSelectOn: !this.state.multiSelectOn,
        });
    }

    onEditMultiSelect() {
        const {
            localization,
            singleChainSortiment,
        } = this.props;

        const title = localization.text("chain", "productDetail");
        const saveButtonText = localization.text("chain", "save");
        this.props.setModal(<MultiProductModal localization={localization} onCloseModal={this.closeProductModal} width={920} title={title} saveButtonText={saveButtonText} selected={singleChainSortiment.selected} />);
    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    onExportCsv() {
        const {
            singleChainSortiment,
            exportCsv,
        } = this.props;

        exportCsv(singleChainSortiment);
    }


    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        return tabPanelHeight;
    }

    render() {
        const {
            clearChainProductDetails,
            currentView,
            deviceType,
            height,
            loadMoreSearchResults,
            localization,
            setModal,
            singleChainSortiment,
            width,
            editSelectedProduct,
        } = this.props;
        const tabPanelHeight = this.calculateInternalPanelHeight();
        let anyProductsSelected = false;
        for(const key in singleChainSortiment.selected) {
            if( singleChainSortiment.selected.hasOwnProperty(key) && singleChainSortiment.selected[key] ){
                anyProductsSelected = true;
                break;
            }
        }

        return (
            <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height}px`, width: `${width}px` }}>
                <ChainTabs startTabId={currentView}>
                    <ChainTabList >
                        <ChainTab id="all" label={localization.text("chain", "chainSortiment", "inYourChain", { count: 1234 })} onClick={this.onTabAllClicked} />
                        <ChainTab id="new" label={localization.text("chain", "chainSortiment", "lastChanged", { count: 12 })} onClick={this.onTabNewClicked} />
                        <SubMenu border={true} style={{flex:`0 0 ${anyProductsSelected?"300px":"61px"}`}}>
                            <SubMenuItem side="right" roundCornerTopRight={true} onClick={this.onExportCsv} isDroppedDown={false} iconType={iconTypes.csvFile} />
                        </SubMenu>
                        <SubMenu border={true} style={{flex:`0 0 ${anyProductsSelected?"300px":"61px"}`}}>
                            <SubMenuItem side="right" roundCornerTopRight={true} onClick={this.onMultiSelectClick} isDroppedDown={false} iconType={iconTypes.checkboxChecked} darkTheme={this.state.multiSelectOn} />
                            {anyProductsSelected && (
                                <SubMenuItem side="right" onClick={this.onEditMultiSelect}>
                                    <div className="selected-menu-button noselect" style={{display:"flex", alignItems:"center", paddingRight:"16px"}}>
                                        <Icon className="menu-icon" type={iconTypes.pen} />
                                        {localization.text("chain", "editSelected")}
                                    </div>
                                </SubMenuItem>
                            )}
                        </SubMenu>
                    </ChainTabList>
                    <ChainTabPanel>
                        <SingleChainSortimentList
                            clearChainProductDetails={clearChainProductDetails}
                            deviceType={deviceType}
                            height={tabPanelHeight}
                            isLoading={singleChainSortiment.isLoading}
                            list={singleChainSortiment.chainProducts}
                            loadMoreProducts={loadMoreSearchResults}
                            localization={localization}
                            setModal={setModal}
                            multiSelect={this.state.multiSelectOn}
                            editSelectedProduct={editSelectedProduct}
                            selected={singleChainSortiment.selected}
                        />
                    </ChainTabPanel>
                    <ChainTabPanel>
                        <SingleChainSortimentList
                            clearChainProductDetails={clearChainProductDetails}
                            deviceType={deviceType}
                            height={tabPanelHeight}
                            isLoading={singleChainSortiment.isLoading}
                            list={singleChainSortiment.chainProducts}
                            loadMoreProducts={loadMoreSearchResults}
                            localization={localization}
                            setModal={setModal}
                            multiSelect={this.state.multiSelectOn}
                            editSelectedProduct={editSelectedProduct}
                            selected={singleChainSortiment.selected}
                        />
                    </ChainTabPanel>
                </ChainTabs>
            </div>
        );
    }
}

SingleChainSortimentCard.propTypes = {
    clearChainProductDetails: PropTypes.func.isRequired,
    currentView: PropTypes.string,
    deviceType: PropTypes.string.isRequired,
    editSingleChainFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    loadMoreSearchResults: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    location: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    singleChainSortiment: PropTypes.object.isRequired,
    width: PropTypes.number.isRequired,
    editSelectedProduct: PropTypes.func.isRequired,
    clearSelectedProducts: PropTypes.func.isRequired,
    exportCsv : PropTypes.func.isRequired,
};

SingleChainSortimentCard.defaultProps = {
    currentView: "all",
};
export default withRouter(SingleChainSortimentCard);
